import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-500 ease-out rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1A1A2E] text-white hover:bg-[#1A1A2E]/90 hover:-translate-y-0.5 shadow-lg shadow-[#1A1A2E]/20 focus:ring-[#1A1A2E]',
    secondary: 'bg-transparent border border-[#1A1A2E] text-[#1A1A2E] hover:bg-[#1A1A2E]/5 focus:ring-[#1A1A2E]',
    accent: 'bg-[#C9A227] text-[#1A1A2E] hover:bg-[#D4B038] hover:-translate-y-0.5 shadow-lg shadow-[#C9A227]/20 focus:ring-[#C9A227]',
    ghost: 'bg-transparent text-[#1A1A2E] hover:bg-[#1A1A2E]/5 focus:ring-[#1A1A2E]'
  };
  const sizes = {
    sm: 'h-8 px-4 text-xs tracking-wider uppercase',
    md: 'h-12 px-8 text-sm tracking-wide uppercase',
    lg: 'h-14 px-10 text-base tracking-widest uppercase'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-13">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-14" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-15">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-16">{rightIcon}</span>}
    </button>;
}